<template>
  <div class="p-postEditor__itemWrapper">
    <div v-if="editingItemIndex != index" @click="editItem">
      <item-preview :item="item" />
    </div>
    <item-form v-if="editingItemIndex == index" :item="item">
      <v-textarea
        :value="editingItemable.content"
        class="body-2"
        :rules="[presenceValidation]"
        label="引用文"
        rows="1"
        auto-grow
        autofocus
        required
        @input="(value) => updateEditingItemable(value, 'content')"
      />
      <v-text-field
        :value="editingItemable.source"
        :rules="[presenceValidation]"
        label="引用元"
        required
        @input="(value) => updateEditingItemable(value, 'source')"
      />
      <v-text-field
        :value="editingItemable.source_url"
        :rules="[urlValidation]"
        label="引用元URL"
        @input="(value) => updateEditingItemable(value, 'source_url')"
      />
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'QuotationItem',
  mixins: [itemUtilsMixin, formValidationUtils],
  data: () => {
    return {}
  },
  computed: {
    title: function () {
      return this.item.itemableAttributes.title
    },
    content: function () {
      return this.item.itemableAttributes.content
    }
  }
}
</script>

<style scoped></style>
